import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Fieldset, M_SwitchButton } from 'src/M_Components'

export const Configuration = ({ }) => {
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()

    return (
        <div>
            <M_Fieldset
                labelInside
                label={t('Configuration')}
                elements={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span>{t("UseCommaSeparator")}</span>
                        <M_SwitchButton
                            checked={ctx.useComma}
                            onClick={(e) => ctx.setUseComma(e.target.checked)}
                        />
                    </div>
                }
            />
        </div>
    )
}
